import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sn-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnEmptyStateComponent {
  @Input() public icon: string;
  @Input() public fontSet: string;
  @Input() public fontIcon: string;
  @Input() public title: string;
}
